import React, { useEffect, useState } from "react";
import "./Setting.css";
import {
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Switch,
  TextField,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Popover,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import insta from "../../../assets/socialmedia/instagram.svg";
import facebook from "../../../assets/socialmedia/faceBuk.svg";
import linkedin from "../../../assets/socialmedia/linkdn.svg";
import x from "../../../assets/socialmedia/x.svg";
import youtube from "../../../assets/socialmedia/youtube.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import SchedulePostModal from "./SetSchdule";
import ResetPasswordModal from "./ResetPasswordModal";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import {
  getBusinessPageLinks,
  deleteScheduleExternalPost,
  deletePost,
  enablePlatforms,
  getAllPlatforms,
  getScheduleExternalPost,
  getOrgSuccessfulSchedulePost,
  updateScheduleExternalPost,
  postDetailsByPostId,
  updatePostMedia,
} from "../../../services/postService";
import {
  fetchOrgTrendingTopics,
  saveOrgTrendingTopics,
  employeeTrendingTopics,
  saveEmployeeTrendingTopics,
  globalTrendingTopics,
} from "../../../services/adminServices";
import EditScheduleModal from "./EditScheduleModal";
import RescheduleModal from "./RescheduleModal";
import EditIcon from "@mui/icons-material/Edit";
import ScheduleIcon from "@mui/icons-material/Schedule";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { toast } from "react-toastify";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { Auth } from "../../../contexts/AuthContext";
import OrganizationSettings from "./OrganizationSettings";
import { useLocation, useNavigate } from "react-router-dom";
import BigCalendar from "./BigCalendar";
import {
  getBunnyEmbedUrl,
  getResolvedImageUrl,
  getResolvedPosterUrl,
  getResolvedVideoUrl,
  isBunnyStreamMedia,
} from "../../../shared/mediaResolver";
import noimg from "../../../assets/noimage.jpg";
import LinkPreview from "../../../shared/LinkPreview";

const socialMediaPlatforms = [
  {
    name: "LinkedIn",
    icon: <img src={linkedin} alt="linkedin" />,
    key: "linkedin",
  },
  {
    name: "Twitter / X",
    icon: <img src={x} alt="twitter" />,
    key: "twitter",
  },
  // {
  //   name: "Instagram",
  //   icon: <img src={insta} alt="insta" />,
  //   key: "instagram",
  // },
  // {
  //   name: "YouTube",
  //   icon: <img src={youtube} alt="youtube" style={{ width: "20px", height: "20px" }} />,
  //   key: "youtube",
  // },
  // {
  //   name: "Facebook",
  //   icon: <img src={facebook} alt="facebook" />,
  //   key: "facebook",
  // },
];

const parseTopics = (value) => {
  return value
    .split(",")
    .map((topic) => topic.trim())
    .filter(Boolean);
};

const buildBusinessPagesFromTrackSelf = (socialMediaConnectionData = []) =>
  socialMediaConnectionData.reduce((acc, item) => {
    const platformKey = item?.platform?.toLowerCase();
    if (!platformKey || item?.status !== "CONNECTED") {
      return acc;
    }
    const normalizedKey =
      platformKey === "x" || platformKey === "twitter" ? "x" : platformKey;
    acc[normalizedKey] = {
      url: item?.businessPageLink || "",
      username: "",
      tagText: "",
      oauthSourcePage: item?.oauthSourcePage || null,
    };
    return acc;
  }, {});

const extractBusinessPageLinks = (businessPages = {}) =>
  Object.entries(businessPages).reduce((acc, [platform, info]) => {
    acc[platform] = info?.url || "";
    return acc;
  }, {});

const getStoredRoles = () => {
  const rawRole = sessionStorage.getItem("role");
  if (!rawRole) {
    return [];
  }

  try {
    const parsedRole = JSON.parse(rawRole);
    return Array.isArray(parsedRole) ? parsedRole : [parsedRole];
  } catch (error) {
    return [rawRole];
  }
};

const accordionSx = {
  background: "#f5f5f5",
  borderRadius: "8px !important",
  boxShadow: "none",
  "&::before": { display: "none" },
  "&.Mui-expanded": {
    margin: "0 !important",
  },
  "& .MuiAccordionSummary-root": {
    width: "100%",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
    "&:hover .MuiTouchRipple-root": {
      display: "none",
    },
  },
  "& .MuiButtonBase-root:hover": {
    backgroundColor: "transparent !important",
  },
};

const accordionSummarySx = {
  px: 2,
  pr: 2,
  width: "100%",
  boxSizing: "border-box",
  minHeight: "64px !important",
  "&:hover": {
    backgroundColor: "transparent !important",
  },
  "&.Mui-expanded": {
    minHeight: "64px !important",
  },
  "& .MuiAccordionSummary-content": {
    margin: "0 !important",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: "0 !important",
  },
  "& .MuiTouchRipple-root": {
    display: "none",
  },
};

const accordionDetailsSx = {
  background: "#ffffff8f",
  borderRadius: "8px",
  mt: 1,
  p: 2,
};


const getDisplayContent = (content) => {
  if (!content) return "No content";
  try {
    const str = String(content).trim();
    if (str.startsWith("[") && str.endsWith("]")) {
      const escapedStr = str.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t");
      const parsed = JSON.parse(escapedStr);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed[0].content || "No content";
      }
    }
  } catch (e) {
    // ignore
  }
  return content;
};

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [expandIntegrations, setExpandIntegrations] = useState(false);
  const [socialMedia, setSocialMedia] = useState({
    instagram: false,
    facebook: false,
    twitter: false,
    linkedin: false,
    youtube: false,
  });
  const [platformToggler, setPlatformToggler] = useState(false);
  const [isDisconnect, setIsDisconnect] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [isPlatformActionLoading, setIsPlatformActionLoading] = useState(false);
  const [platformActionError, setPlatformActionError] = useState("");
  const [discard, setDiscard] = useState(false);
  const [deleteScheduleLoading, setDeleteScheduleLoading] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [schedulePosts, setSchedulePosts] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [rescheduleModalOpen, setRescheduleModalOpen] = useState(false);
  const [selectedSchedulePost, setSelectedSchedulePost] = useState(null);
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [orgSchedulePosts, setOrgSchedulePosts] = useState([]);
  const [viewOnlyModalOpen, setViewOnlyModalOpen] = useState(false);
  const [viewOnlyPost, setViewOnlyPost] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [, setSettingsError] = useState(null);
  const [trendingTopics, setTrendingTopics] = useState([]);
  const [orgTopics, setOrgTopics] = useState([]);
  const [trendingInput, setTrendingInput] = useState("");
  const [isSavingTrending, setIsSavingTrending] = useState(false);
  const [trendingHelperText, setTrendingHelperText] = useState("");
  const [limitExceeded, setLimitExceeded] = useState(false);
  const TRENDING_LIMIT = 30;
  const [trendingExpanded, setTrendingExpanded] = useState(false);
  const [personalTrendingExpanded, setPersonalTrendingExpanded] = useState(false);
  // Admin personal trending topics (separate from org topics)
  const [adminPersonalTopics, setAdminPersonalTopics] = useState([]);
  const [adminPersonalInput, setAdminPersonalInput] = useState("");
  const [isSavingAdminPersonal, setIsSavingAdminPersonal] = useState(false);
  const [adminPersonalHelperText, setAdminPersonalHelperText] = useState("");
  const [adminPersonalLimitExceeded, setAdminPersonalLimitExceeded] = useState(false);
  const [adminPersonalExpanded, setAdminPersonalExpanded] = useState(false);
  const [scheduleExpanded, setScheduleExpanded] = useState(false);
  const [resetPasswordExpanded, setResetPasswordExpanded] = useState(false);
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
  const [scheduleErrorMessage, setScheduleErrorMessage] = useState("");
  const [viewMode, setViewMode] = useState("list");
  const [selectedPreviewPost, setSelectedPreviewPost] = useState(null);
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [viewMoreOpen, setViewMoreOpen] = useState(false);
  const [viewMorePosts, setViewMorePosts] = useState([]);
  const [viewMoreDate, setViewMoreDate] = useState("");
  const [viewMoreAnchorEl, setViewMoreAnchorEl] = useState(null);
  const [currentView, setCurrentView] = useState("month");
  const [fullscreenView, setFullscreenView] = useState("month");

  const handleOpenViewMorePopup = (posts, dateStr, anchor = null) => {
    setViewMorePosts(posts);
    setViewMoreDate(dateStr);
    setViewMoreAnchorEl(anchor);
    setViewMoreOpen(true);
  };
  const { setBusinessPages } = Auth();

  const onboarding = useOnboarding();

  useEffect(() => {
    if (onboarding && onboarding.isOnboardingActive) {
      if (onboarding.activeStep === 0) {
        setExpandIntegrations(true);
        setTrendingExpanded(false);
      } else if (onboarding.activeStep === 1) {
        setTrendingExpanded(true);
        setExpandIntegrations(false);
      }
    }
  }, [onboarding?.activeStep, onboarding?.isOnboardingActive]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const openSection = searchParams.get("open") || searchParams.get("section");
    if (
      location.state?.openPersonalAccounts ||
      openSection === "personal" ||
      openSection === "personal-accounts"
    ) {
      setExpandIntegrations(true);

      const scrollToSection = () => {
        const el = document.getElementById("onboarding-personal-accounts-accordion");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          const scrollContainer =
            document.querySelector(".postContentContainer") ||
            el.closest(".postContentContainer");
          if (scrollContainer && scrollContainer.scrollTo) {
            scrollContainer.scrollTo({
              top: Math.max(0, el.offsetTop - 15),
              behavior: "smooth",
            });
          }
        }
      };

      setTimeout(scrollToSection, 150);
      setTimeout(scrollToSection, 450);
    }
  }, [location.state, location.search]);

  const resolveSourcePage = () =>
    isAdminUser ? "ADMIN_SETTINGS" : "EMPLOYEE_SETTINGS";

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("socialConnect");
    const platform = params.get("platform");
    const reason = params.get("reason");

    if (!status || !platform) {
      return;
    }

    const platformLabel =
      socialMediaPlatforms.find(
        (item) => item.key === platform.toLowerCase() || (platform.toLowerCase() === "x" && item.key === "twitter")
      )?.name || platform;

    if (status === "success") {
      toast.success(`${platformLabel} connected successfully.`);
      fetchAllSocialMedia();
    } else if (status === "error") {
      const reasonLabel = reason
        ? reason.replace(/_/g, " ")
        : "Please try again.";
      toast.error(`${platformLabel} connection failed: ${reasonLabel}.`);
    }

    params.delete("socialConnect");
    params.delete("platform");
    params.delete("reason");
    navigate(
      {
        pathname: location.pathname,
        search: params.toString() ? `?${params.toString()}` : "",
      },
      { replace: true }
    );
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    if (selectedPreviewPost && !selectedPreviewPost.postDetails && selectedPreviewPost.postId) {
      const loadPreviewDetails = async () => {
        try {
          const details = await postDetailsByPostId(selectedPreviewPost.postId);
          if (details && details.status && details.posts && details.posts[0]) {
            setSelectedPreviewPost((prev) => {
              if (prev && prev.id === selectedPreviewPost.id) {
                return { ...prev, postDetails: details.posts[0] };
              }
              return prev;
            });
            setSchedulePosts((prevPosts) =>
              prevPosts.map((p) =>
                p.id === selectedPreviewPost.id
                  ? { ...p, postDetails: details.posts[0] }
                  : p
              )
            );
          }
        } catch (err) {
          console.error("Failed to load preview details:", err);
        }
      };
      loadPreviewDetails();
    }
  }, [selectedPreviewPost]);

  useEffect(() => {
    const handleOnboardingAction = (e) => {
      const { action } = e.detail || {};
      if (action === "expand-personal-accounts") {
        setExpandIntegrations(true);
        setTimeout(() => {
          const el = document.getElementById("onboarding-personal-accounts-accordion");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      } else if (action === "expand-trending-topics") {
        setTrendingExpanded(true);
        setTimeout(() => {
          const el = document.getElementById("onboarding-trending-topics-accordion");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      } else if (action === "expand-personal-trending-topics") {
        setPersonalTrendingExpanded(true);
        setTimeout(() => {
          const el = document.getElementById("onboarding-personal-trending-topics-accordion");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      } else if (action === "expand-admin-personal-trending-topics") {
        setAdminPersonalExpanded(true);
        setTimeout(() => {
          const el = document.getElementById("onboarding-admin-personal-trending-accordion");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      }
    };
    window.addEventListener("onboarding-action", handleOnboardingAction);
    return () => window.removeEventListener("onboarding-action", handleOnboardingAction);
  }, []);


  const handleConfirm = async () => {
    setDeleteScheduleLoading(true);
    try {
      const scheduleId = selectedId?.id || selectedId; // Fallback for backward compatibility
      const postId = selectedId?.postId;

      // Delete only the schedule entry — do NOT delete the core post (it should stay in timeline)
      const response = await deleteScheduleExternalPost(scheduleId);

      if (response?.status === true) {
        fetchAllSchedule();
        toast.success("Scheduled post successfully deleted");
        if (selectedPreviewPost && selectedPreviewPost.id === scheduleId) {
          setSelectedPreviewPost(null);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDeleteScheduleLoading(false);
      setDiscard(false);
    }
  };
  const handleDiscard = (item) => {
    setSelectedId(item); // Storing the full item instead of just id
    setDiscard(true);
  };

  const handleToggle = (platform) => {
    const isAlreadyConnected = socialMedia[platform];

    // ✅ if platform is "twitter", set to "X"
    const selected = platform.toLowerCase() === "twitter" ? "X" : platform;

    setSelectedPlatform(selected);
    setIsDisconnect(isAlreadyConnected);
    setPlatformActionError("");
    setPlatformToggler(true);
  };

  const handleSchedule = () => {
    setOpen(true);
  };

  const fetchAllSocialMedia = async () => {
    setSettingsLoading(true);
    setSettingsError(null);
    try {
      const response = await getAllPlatforms();
      if (response?.status === true) {
        const data = response?.socialMediaConnectionData || [];

        // map API data to state
        const updatedSocialMedia = {
          instagram: false,
          facebook: false,
          twitter: false,
          linkedin: false,
          youtube: false,
        };

        data.forEach((item) => {
          if (item.status === "CONNECTED") {
            if (
              item.platform.toLowerCase() === "x" ||
              item.platform.toLowerCase() === "twitter"
            ) {
              updatedSocialMedia.twitter = true;
            } else if (item.platform.toLowerCase() === "instagram") {
              updatedSocialMedia.instagram = true;
            } else if (item.platform.toLowerCase() === "facebook") {
              updatedSocialMedia.facebook = true;
            } else if (item.platform.toLowerCase() === "linkedin") {
              updatedSocialMedia.linkedin = true;
            } else if (item.platform.toLowerCase() === "youtube") {
              updatedSocialMedia.youtube = true;
            }
          }
        });

        // set state
        setSocialMedia(updatedSocialMedia); // ✅ Auto toggle ON for connected platforms
        const businessPages = buildBusinessPagesFromTrackSelf(data);
        setBusinessPages(businessPages);
        sessionStorage.setItem("businessPages", JSON.stringify(businessPages));
        sessionStorage.setItem(
          "businessPageLinks",
          JSON.stringify(extractBusinessPageLinks(businessPages))
        );
      }
    } catch (error) {
      console.log(error);
      setSettingsError("Failed to load settings. Please refresh the page.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const enablePlatform = async () => {
    if (!selectedPlatform) {
      return;
    }

    setIsPlatformActionLoading(true);
    setPlatformActionError("");

    try {
      const payload = {
        platform: selectedPlatform.toUpperCase(),
        connect: !isDisconnect, // false if disconnecting
        sourcePage: resolveSourcePage(),
      };

      const response = await enablePlatforms(payload);

      if (response?.authUrl) {
        window.location.href = response?.authUrl;
        return;
      }

      if (response?.status === true) {
        setSocialMedia((prev) => ({
          ...prev,
          [selectedPlatform.toLowerCase()]: !isDisconnect,
        }));
        fetchAllSocialMedia();
        const linksResponse = await getBusinessPageLinks();
        if (linksResponse?.status === true) {
          const businessPages = linksResponse?.businessPages || {};
          setBusinessPages(businessPages);
          sessionStorage.setItem("businessPages", JSON.stringify(businessPages));
          sessionStorage.setItem(
            "businessPageLinks",
            JSON.stringify(extractBusinessPageLinks(businessPages))
          );
        }
        setPlatformToggler(false);
        return;
      }

      const fallbackMessage =
        response?.message ||
        `Unable to ${isDisconnect ? "disconnect" : "connect"} ${selectedPlatform}.`;
      setPlatformActionError(fallbackMessage);
      toast.error(fallbackMessage);
    } catch (error) {
      const errorMessage =
        error?.message ||
        `Unable to ${isDisconnect ? "disconnect" : "connect"} ${selectedPlatform}.`;
      setPlatformActionError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsPlatformActionLoading(false);
    }
  };

  useEffect(() => {
    fetchAllSocialMedia();
  }, []);

  useEffect(() => {
    const admin = getStoredRoles().includes("ROLE_ADMIN");
    setIsAdminUser(admin);
    if (admin) {
      loadTrendingTopics();
      loadAdminPersonalTopics();
    } else {
      loadEmployeeTrendingTopics();
    }
  }, []);

  const loadEmployeeTrendingTopics = async () => {
    try {
      const response = await employeeTrendingTopics().catch(() => null);
      const orgResponse = await globalTrendingTopics().catch(() => null);

      const fetchedOrgTopics = orgResponse?.trendingTopics || orgResponse?.topics || [];
      setOrgTopics(fetchedOrgTopics);

      const dbTopics = response?.trendingTopics || response?.topics || [];
      setTrendingTopics(dbTopics);
      setTrendingInput(dbTopics.join(", "));
    } catch (error) {
      console.error("Unable to load trending topics", error);
    }
  };

  const loadTrendingTopics = async () => {
    try {
      const response = await globalTrendingTopics();
      const topics = response?.trendingTopics || response?.topics || [];
      const limited = topics.slice(0, TRENDING_LIMIT);
      setTrendingTopics(limited);
      setOrgTopics(limited);
      setTrendingInput(limited.join(", "));
      if (topics.length > TRENDING_LIMIT) {
        setLimitExceeded(true);
        setTrendingHelperText(`Maximum ${TRENDING_LIMIT} topics allowed.`);
      } else {
        setLimitExceeded(false);
        setTrendingHelperText("");
      }
    } catch (error) {
      console.error("Unable to load trending topics", error);
    }
  };

  const loadAdminPersonalTopics = async () => {
    try {
      const response = await employeeTrendingTopics().catch(() => null);
      const topics = response?.trendingTopics || response?.topics || [];
      setAdminPersonalTopics(topics);
      setAdminPersonalInput(topics.join(", "));
    } catch (error) {
      console.error("Unable to load admin personal topics", error);
    }
  };

  const handleAdminPersonalInputChange = (event) => {
    const value = event?.target?.value || "";
    const parsed = parseTopics(value);
    const unique = Array.from(new Set(parsed)).slice(0, TRENDING_LIMIT);
    setAdminPersonalInput(value);
    setAdminPersonalTopics(unique);
    if (parsed.length > TRENDING_LIMIT) {
      setAdminPersonalLimitExceeded(true);
      setAdminPersonalHelperText(`Maximum ${TRENDING_LIMIT} topics allowed.`);
    } else {
      setAdminPersonalLimitExceeded(false);
      setAdminPersonalHelperText("");
    }
  };

  const handleAdminPersonalRemove = (topic) => {
    const updated = adminPersonalTopics.filter(t => t !== topic);
    setAdminPersonalTopics(updated);
    setAdminPersonalInput(updated.join(", "));
    setAdminPersonalLimitExceeded(false);
    setAdminPersonalHelperText("");
  };

  const handleAdminPersonalSave = async () => {
    if (adminPersonalLimitExceeded || adminPersonalTopics.length === 0) return;
    setIsSavingAdminPersonal(true);
    try {
      await saveEmployeeTrendingTopics(adminPersonalTopics);
      toast.success("Personal topics updated.");
      await loadAdminPersonalTopics();
    } catch (error) {
      toast.error(error.message || "Failed to save personal topics.");
    } finally {
      setIsSavingAdminPersonal(false);
    }
  };

  const handleAdminPersonalClear = async () => {
    if (isSavingAdminPersonal) return;
    setIsSavingAdminPersonal(true);
    try {
      await saveEmployeeTrendingTopics([]);
      setAdminPersonalTopics([]);
      setAdminPersonalInput("");
      toast.success("Personal topics cleared.");
    } catch (error) {
      toast.error(error.message || "Failed to clear personal topics.");
    } finally {
      setIsSavingAdminPersonal(false);
    }
  };

  const handleTrendingInputChange = (event) => {
    const value = event?.target?.value || "";
    const parsed = parseTopics(value);
    const uniqueTopics = Array.from(new Set(parsed));
    const limited = uniqueTopics.slice(0, TRENDING_LIMIT);
    setTrendingInput(value);
    setTrendingTopics(limited);
    if (uniqueTopics.length > TRENDING_LIMIT) {
      setLimitExceeded(true);
      setTrendingHelperText(`Maximum ${TRENDING_LIMIT} topics allowed.`);
    } else {
      setLimitExceeded(false);
      setTrendingHelperText("");
    }
  };

  const handleRemoveTopic = (topicToRemove) => {
    const updatedTopics = trendingTopics.filter(
      (topic) => topic !== topicToRemove
    );
    setTrendingTopics(updatedTopics);
    setTrendingInput(updatedTopics.join(", "));
    setLimitExceeded(false);
    setTrendingHelperText("");
  };

  const handleTrendingSave = async () => {
    if (limitExceeded) {
      setTrendingHelperText(`Maximum ${TRENDING_LIMIT} topics allowed.`);
      return;
    }
    if (trendingTopics.length === 0) {
      setTrendingHelperText("Add at least one topic.");
      return;
    }

    setIsSavingTrending(true);
    try {
      if (isAdminUser) {
        await saveOrgTrendingTopics(trendingTopics);
        setTrendingHelperText("");
        toast.success("Trending topics updated.");
        await loadTrendingTopics();
      } else {
        await saveEmployeeTrendingTopics(trendingTopics);
        setTrendingHelperText("");
        toast.success("Personal topics updated.");
        await loadEmployeeTrendingTopics();
      }
    } catch (error) {
      setTrendingHelperText("Unable to save topics right now.");
      toast.error(error.message || "Failed to save trending topics.");
    } finally {
      setIsSavingTrending(false);
    }
  };

  const handleTrendingClear = async () => {
    if (isSavingTrending) {
      return;
    }
    setIsSavingTrending(true);
    try {
      if (isAdminUser) {
        await saveOrgTrendingTopics([]);
        setTrendingTopics([]);
        setTrendingInput("");
        setLimitExceeded(false);
        setTrendingHelperText("Custom preferences cleared. Showing default topics.");
        toast.success("Trending topic preferences reset.");
      } else {
        await saveEmployeeTrendingTopics([]);
        setTrendingTopics([]);
        setTrendingInput("");
        setLimitExceeded(false);
        setTrendingHelperText("Personal topics cleared.");
        toast.success("Personal topic preferences reset.");
      }
    } catch (error) {
      setTrendingHelperText("Unable to clear topics right now.");
      toast.error(error.message || "Failed to clear trending topics.");
    } finally {
      setIsSavingTrending(false);
    }
  };

  const sortSchedulesLatestFirst = (list = []) => {
    return [...list].sort((a, b) => {
      if (b.id && a.id && b.id !== a.id) {
        return b.id - a.id;
      }
      const timeA = new Date(a.scheduledTimeUtc || 0).getTime();
      const timeB = new Date(b.scheduledTimeUtc || 0).getTime();
      return timeB - timeA;
    });
  };

  const fetchAllSchedule = async () => {
    setIsLoadingSchedule(true);
    setScheduleErrorMessage("");
    try {
      const response = await getScheduleExternalPost();
      if (response?.status === true) {
        const rawList = response?.schedulePostList || [];
        const postsList = sortSchedulesLatestFirst(rawList);
        setSchedulePosts(postsList);

        // Fetch details in parallel in background
        Promise.all(
          postsList.map(async (item) => {
            if (item.postId) {
              try {
                const details = await postDetailsByPostId(item.postId);
                if (details && details.status && details.posts && details.posts[0]) {
                  return { ...item, postDetails: details.posts[0] };
                }
              } catch (err) {
                console.error("Failed to fetch post details for", item.postId, err);
              }
            }
            return item;
          })
        ).then((enrichedList) => {
          const sortedEnriched = sortSchedulesLatestFirst(enrichedList);
          setSchedulePosts(sortedEnriched);

          // Keep selectedPreviewPost up to date
          setSelectedPreviewPost((prev) => {
            if (prev) {
              const updated = sortedEnriched.find((p) => p.id === prev.id);
              if (updated) return updated;
            }
            return prev;
          });
        });
      } else {
        setSchedulePosts([]);
      }
    } catch (error) {
      setSchedulePosts([]);
      setScheduleErrorMessage(
        error.message ||
        "Scheduler service is temporarily unavailable. Please retry in a moment."
      );
      toast.error(
        error.message ||
        "Scheduler service is temporarily unavailable. Please retry in a moment."
      );
    } finally {
      setIsLoadingSchedule(false);
    }
  };

  const openAccordian = () => {
    fetchAllSchedule();
  };

  const fetchOrgSchedules = async () => {
    try {
      const response = await getOrgSuccessfulSchedulePost();
      if (response?.status === true) {
        const postsList = (response?.schedulePostList || []).map(item => ({ ...item, isOrgPost: true }));
        setOrgSchedulePosts(postsList);
      } else {
        setOrgSchedulePosts([]);
      }
    } catch (error) {
      setOrgSchedulePosts([]);
    }
  };

  const handleViewOnlyPost = (post) => {
    setViewOnlyPost(post);
    setViewOnlyModalOpen(true);
  };

  const handleCancel = () => {
    setSelectedId();
    setDiscard(false);
  };

  const handleEditView = (post) => {
    setSelectedSchedulePost(post);
    setEditModalOpen(true);
  };

  const handleReschedule = (post) => {
    setSelectedSchedulePost(post);
    setRescheduleModalOpen(true);
  };

  const handleEditSave = async (updatedData) => {
    try {
      // Map platforms to uppercase format for API
      const platformMapping = {
        instagram: "INSTAGRAM",
        facebook: "FACEBOOK",
        linkedin: "LINKEDIN",
        twitter: "X",
        "twitter/x": "X",
        x: "X",
        youtube: "YOUTUBE",
      };
      const formattedPlatforms = (updatedData.platforms || []).map(
        (p) => platformMapping[p.toLowerCase()] || p.toUpperCase()
      );

      const payload = {
        id: updatedData.id,
        postId: updatedData.postId,
        content: updatedData.content,
        type: updatedData.type,
        platforms: formattedPlatforms,
        scheduledTimeUtc: updatedData.scheduledTimeUtc,
        media: (updatedData.media || []).map(m => ({
          id: m.id,
          fileUrl: m.fileUrl,
          mediaType: (m.mediaType || "").toUpperCase(),
          thumbnailUrl: m.thumbnailUrl,
          processingStatus: m.processingStatus,
        })),
      };
      const response = await updateScheduleExternalPost(payload);
      if (response?.status === true) {
        toast.success("Post updated successfully");
        const updatedMediaIds = (updatedData.media || []).map(m => m.id).filter(Boolean);
        // Also update core post media so Timeline shows the correct image
        if (updatedData.postId && updatedData.media?.length > 0) {
          updatePostMedia(updatedData.postId, updatedData.media.map(m => ({
            id: m.id, fileUrl: m.fileUrl, mediaType: (m.mediaType || "").toUpperCase(),
            thumbnailUrl: m.thumbnailUrl, processingStatus: m.processingStatus,
          })));
        }
        setSchedulePosts((prev) =>
          prev.map((p) =>
            p.id === updatedData.id
              ? { ...p, content: updatedData.content, media: updatedData.media || [], mediaIds: updatedMediaIds }
              : p
          )
        );
        fetchAllSchedule();
        setEditModalOpen(false);
        setSelectedSchedulePost(null);
        if (selectedPreviewPost && selectedPreviewPost.id === updatedData.id) {
          setSelectedPreviewPost((prev) => ({
            ...prev,
            ...updatedData,
            media: updatedData.media || [],
            scheduledTimeUtc: updatedData.scheduledTimeUtc,
            updatedAt: new Date().toISOString(),
          }));
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update post");
    }
  };

  const handleRescheduleSave = async (updatedData) => {
    try {
      // Map platforms to uppercase format for API
      const platformMapping = {
        instagram: "INSTAGRAM",
        facebook: "FACEBOOK",
        linkedin: "LINKEDIN",
        twitter: "X",
        "twitter/x": "X",
        x: "X",
        youtube: "YOUTUBE",
      };
      const formattedPlatforms = (updatedData.platforms || []).map(
        (p) => platformMapping[p.toLowerCase()] || p.toUpperCase()
      );

      const payload = {
        id: updatedData.id,
        postId: updatedData.postId,
        content: updatedData.content,
        type: "POST",
        platforms: formattedPlatforms,
        scheduledTimeUtc: updatedData.scheduledTimeUtc,
      };
      const response = await updateScheduleExternalPost(payload);
      if (response?.status === true) {
        toast.success("Post rescheduled successfully");
        fetchAllSchedule();
        setRescheduleModalOpen(false);
        setSelectedSchedulePost(null);
        if (selectedPreviewPost && selectedPreviewPost.id === updatedData.id) {
          setSelectedPreviewPost((prev) => ({
            ...prev,
            ...updatedData,
            scheduledTimeUtc: updatedData.scheduledTimeUtc,
          }));
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to reschedule post");
    }
  };

  const displayedPosts = schedulePosts;

  return (
    <Card className="settings-container">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {isAdminUser && <OrganizationSettings />}

        {isAdminUser ? (
          <>
          <Accordion
            id="onboarding-trending-topics-accordion"
            expanded={trendingExpanded}
            onChange={(_, isExpanded) => setTrendingExpanded(isExpanded)}
            sx={accordionSx}
          >
            <AccordionSummary
              id="onboarding-trending-topics-header"
              expandIcon={<ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />}
              sx={accordionSummarySx}
            >
              <div className="reset-password">
                <div>
                  <Typography variant="subtitle1" className="sub-title">
                    Organisation Trending Topic
                  </Typography>
                  <Typography variant="body2" className="mini-title">
                    Add up to {TRENDING_LIMIT} comma-separated topics to highlight what is trending for your organization.
                  </Typography>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <TextField
                placeholder="e.g. Sustainability, Policy, AI Adoption"
                multiline
                minRows={3}
                value={trendingInput}
                onChange={handleTrendingInputChange}
                className="trending-textarea"
                fullWidth
              />
              <Box className="trending-chip-row">
                {trendingTopics.length > 0 ? (
                  trendingTopics.map((topic) => (
                    <Chip
                      key={`personal-${topic}`}
                      label={topic}
                      size="small"
                      onDelete={() => handleRemoveTopic(topic)}
                      sx={{
                        backgroundColor: "#EDEFF2",
                        borderRadius: "12px",
                        fontSize: "12px",
                      }}
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="#95919D">
                    No trending topics configured yet.
                  </Typography>
                )}
              </Box>
              <>
                <Typography
                  variant="body2"
                  className={`helper-text ${limitExceeded ? "error" : ""}`}
                >
                  {trendingHelperText || `Separate topics with commas; max ${TRENDING_LIMIT}.`}
                </Typography>
                <Box className="trending-actions">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleTrendingClear}
                    disabled={isSavingTrending || trendingTopics.length === 0}
                  >
                    Clear Preferences
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleTrendingSave}
                    disabled={
                      isSavingTrending || trendingTopics.length === 0 || limitExceeded
                    }
                  >
                    {isSavingTrending ? "Saving..." : "Save Preferences"}
                  </Button>
                </Box>
              </>
            </AccordionDetails>
          </Accordion>

          {/* Admin Personal Trending Topic */}
          <Accordion
            id="onboarding-admin-personal-trending-accordion"
            expanded={adminPersonalExpanded}
            onChange={(_, isExpanded) => setAdminPersonalExpanded(isExpanded)}
            sx={accordionSx}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />}
              sx={accordionSummarySx}
            >
              <div className="reset-password">
                <div>
                  <Typography variant="subtitle1" className="sub-title">
                    Personal Trending Topic
                  </Typography>
                  <Typography variant="body2" className="mini-title">
                    Add your personal preferred topics for content recommendations.
                  </Typography>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <TextField
                placeholder="e.g. Leadership, Innovation, Growth"
                multiline
                minRows={3}
                value={adminPersonalInput}
                onChange={handleAdminPersonalInputChange}
                className="trending-textarea"
                fullWidth
              />
              <Box className="trending-chip-row">
                {adminPersonalTopics.length > 0 ? (
                  adminPersonalTopics.map((topic) => (
                    <Chip
                      key={`admin-personal-${topic}`}
                      label={topic}
                      size="small"
                      onDelete={() => handleAdminPersonalRemove(topic)}
                      sx={{ backgroundColor: "#EDEFF2", borderRadius: "12px", fontSize: "12px" }}
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="#95919D">
                    No personal topics configured yet.
                  </Typography>
                )}
              </Box>
              <>
                <Typography
                  variant="body2"
                  className={`helper-text ${adminPersonalLimitExceeded ? "error" : ""}`}
                >
                  {adminPersonalHelperText || `Separate topics with commas; max ${TRENDING_LIMIT}.`}
                </Typography>
                <Box className="trending-actions">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleAdminPersonalClear}
                    disabled={isSavingAdminPersonal || adminPersonalTopics.length === 0}
                  >
                    Clear Preferences
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAdminPersonalSave}
                    disabled={isSavingAdminPersonal || adminPersonalTopics.length === 0 || adminPersonalLimitExceeded}
                  >
                    {isSavingAdminPersonal ? "Saving..." : "Save Preferences"}
                  </Button>
                </Box>
              </>
            </AccordionDetails>
          </Accordion>
          </>
        ) : (
          <>
            <Accordion
              id="onboarding-org-trending-topics-accordion"
              expanded={trendingExpanded}
              onChange={(_, isExpanded) => setTrendingExpanded(isExpanded)}
              sx={accordionSx}
            >
              <AccordionSummary
                id="onboarding-org-trending-topics-header"
                expandIcon={<ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />}
                sx={accordionSummarySx}
              >
                <div className="reset-password">
                  <div>
                    <Typography variant="subtitle1" className="sub-title">
                      Organization Trending Topics
                    </Typography>
                    <Typography variant="body2" className="mini-title">
                      Topics configured by your organization admin.
                    </Typography>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails sx={accordionDetailsSx}>
                <Box className="trending-chip-row">
                  {orgTopics.length > 0 ? (
                    orgTopics.map((topic) => (
                      <Chip
                        key={`org-${topic}`}
                        label={topic}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f0fe",
                          color: "#1967d2",
                          borderRadius: "12px",
                          fontSize: "12px",
                        }}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" color="#95919D">
                      No organization trending topics configured yet.
                    </Typography>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>

            <Accordion
              id="onboarding-personal-trending-topics-accordion"
              expanded={personalTrendingExpanded}
              onChange={(_, isExpanded) => setPersonalTrendingExpanded(isExpanded)}
              sx={accordionSx}
            >
              <AccordionSummary
                id="onboarding-personal-trending-topics-header"
                expandIcon={<ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />}
                sx={accordionSummarySx}
              >
                <div className="reset-password">
                  <div>
                    <Typography variant="subtitle1" className="sub-title">
                      Personal Trending Topics
                    </Typography>
                    <Typography variant="body2" className="mini-title">
                      Add your personal preferred topics for content recommendations.
                    </Typography>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails sx={accordionDetailsSx}>
                <TextField
                  placeholder="Add personal preferred topics..."
                  multiline
                  minRows={3}
                  value={trendingInput}
                  onChange={handleTrendingInputChange}
                  className="trending-textarea"
                  fullWidth
                />
                <Box className="trending-chip-row">
                  {trendingTopics.length > 0 ? (
                    trendingTopics.map((topic) => (
                      <Chip
                        key={`personal-${topic}`}
                        label={topic}
                        size="small"
                        onDelete={() => handleRemoveTopic(topic)}
                        sx={{
                          backgroundColor: "#EDEFF2",
                          borderRadius: "12px",
                          fontSize: "12px",
                        }}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" color="#95919D">
                      No personal topics configured yet.
                    </Typography>
                  )}
                </Box>
                <>
                  <Typography
                    variant="body2"
                    className={`helper-text ${limitExceeded ? "error" : ""}`}
                  >
                    {trendingHelperText || `Separate topics with commas; max ${TRENDING_LIMIT}.`}
                  </Typography>
                  <Box className="trending-actions">
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleTrendingClear}
                      disabled={isSavingTrending || trendingTopics.length === 0}
                    >
                      Clear Preferences
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleTrendingSave}
                      disabled={
                        isSavingTrending || trendingTopics.length === 0 || limitExceeded
                      }
                    >
                      {isSavingTrending ? "Saving..." : "Save Preferences"}
                    </Button>
                  </Box>
                </>
              </AccordionDetails>
            </Accordion>
          </>
        )}

        <Accordion
          id="onboarding-personal-accounts-accordion"
          expanded={expandIntegrations}
          onChange={(_, isExpanded) => setExpandIntegrations(isExpanded)}
          sx={accordionSx}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />
            }
            sx={accordionSummarySx}
          >
            <div className="reset-password">
              <div>
                <Typography variant="subtitle1" className="sub-title">
                  Personal Accounts
                </Typography>
                <Typography variant="body2" className="mini-title">
                  Connect your own social profiles for sharing content from the
                  app. These connections are personal and separate from
                  organization business pages.
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails sx={accordionDetailsSx}>
            <List>
              {socialMediaPlatforms?.map(({ name, icon, key }) => (
                <ListItem key={key} className="social-media-item">
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText primary={name} />
                  <ListItemSecondaryAction>
                    <Switch
                      checked={socialMedia[key]}
                      onChange={() => handleToggle(key)}
                      disabled={isPlatformActionLoading}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={scheduleExpanded}
          onChange={(_, isExpanded) => {
            setScheduleExpanded(isExpanded);
            if (isExpanded) {
              openAccordian();
            }
          }}
          sx={accordionSx}
        >
          <AccordionSummary
            id="onboarding-personal-accounts-header"
            expandIcon={
              <ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />
            }
            sx={accordionSummarySx}
          >
            <div className="reset-password">
              <div>
                <Typography variant="subtitle1" className="sub-title">
                  Schedule
                </Typography>
                <Typography variant="body2" className="mini-title">
                  Review and manage queued posts that will publish to connected
                  socials at a scheduled time.
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              ...accordionDetailsSx,
              maxHeight: viewMode === "calendar" ? "650px" : "400px",
              overflowY: "auto",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#ccc",
                borderRadius: "4px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant={viewMode === "calendar" ? "contained" : "outlined"}
                  onClick={() => { setCalendarModalOpen(true); }}
                  sx={{
                    textTransform: "none",
                    borderRadius: "20px",
                    fontWeight: 600,
                    fontSize: "12px",
                    px: 2,
                    py: 0.5,
                    backgroundColor: viewMode === "calendar" ? "#0047AB" : "transparent",
                    color: viewMode === "calendar" ? "#fff" : "#0047AB",
                    borderColor: "#0047AB",
                    "&:hover": {
                      backgroundColor: viewMode === "calendar" ? "#003580" : "rgba(0, 71, 171, 0.04)",
                      borderColor: "#0047AB",
                    }
                  }}
                >
                  Calendar View
                </Button>
                <Button
                  variant={viewMode === "list" ? "contained" : "outlined"}
                  onClick={() => setViewMode("list")}
                  sx={{
                    textTransform: "none",
                    borderRadius: "20px",
                    fontWeight: 600,
                    fontSize: "12px",
                    px: 2,
                    py: 0.5,
                    backgroundColor: viewMode === "list" ? "#0047AB" : "transparent",
                    color: viewMode === "list" ? "#fff" : "#0047AB",
                    borderColor: "#0047AB",
                    "&:hover": {
                      backgroundColor: viewMode === "list" ? "#003580" : "rgba(0, 71, 171, 0.04)",
                      borderColor: "#0047AB",
                    }
                  }}
                >
                  List View
                </Button>
              </Box>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0047AB" }}
                onClick={handleSchedule}
              >
                New Schedule
              </Button>
            </Box>
            {scheduleErrorMessage ? (
              <Typography
                variant="body2"
                sx={{ color: "#CC2D1A", mb: 2, fontWeight: 500 }}
              >
                {scheduleErrorMessage}
              </Typography>
            ) : null}
            {isLoadingSchedule ? (
              <Typography variant="body2" sx={{ color: "#6B7280", mb: 2 }}>
                Loading scheduled posts...
              </Typography>
            ) : null}

            {viewMode === "calendar" ? (
              <BigCalendar
                schedulePosts={displayedPosts}
                view={currentView}
                onView={(view) => setCurrentView(view)}
                onPostClick={(post) => {
                  handleEditView(post);
                  setSelectedPreviewPost(post);
                }}
                onViewMoreClick={(posts, dateStr, anchor) => {
                  handleOpenViewMorePopup(posts, dateStr, anchor);
                }}
                onSelectEvent={(event, jsEvent) => {
                  if (event.resource.isGrouped) {
                    const anchor = jsEvent ? jsEvent.currentTarget || jsEvent.target : null;
                    handleOpenViewMorePopup(event.resource.posts, event.resource.dateStr, anchor);
                  } else {
                    handleEditView(event.resource);
                    setSelectedPreviewPost(event.resource);
                  }
                }}
                containerSx={{
                  height: 550,
                  background: "#fff",
                  borderRadius: "12px",
                  p: 2,
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                  border: "1px solid #E2E8F0"
                }}
              />
            ) : (
              <ul
                style={{
                  margin: 0,
                  fontSize: "16px",
                  paddingLeft: "0px",
                  listStyleType: "none",
                }}
              >
                {displayedPosts?.length > 0 ? (
                  displayedPosts?.map((item, i) => {
                    const localTime = new Date(
                      item.scheduledTimeUtc + (item.scheduledTimeUtc.endsWith('Z') ? '' : 'Z')
                    ).toLocaleString(undefined, {
                      dateStyle: "medium",
                      timeStyle: "short",
                    });
                    const getStatusConfig = () => {
                      if (item.isProcessed !== true) {
                        return {
                          label: "Not Processed",
                          bg: "#F5F5F5",
                          color: "#757575",
                          border: "#BDBDBD",
                        };
                      }
                      if (item.isSuccess === true) {
                        return {
                          label: "Success",
                          bg: "#DBFFDF",
                          color: "#21AD0F",
                          border: "#21AD0F",
                        };
                      }
                      return {
                        label: "Failed",
                        bg: "#FED6D6",
                        color: "#CC2D1A",
                        border: "#CC2D1A",
                      };
                    };

                    const statusConfig = getStatusConfig();
                    
                    const getMediaInfo = (data) => {
                      let mediaObj = null;
                      if (data?.media && data.media.length > 0) {
                        mediaObj = data.media[0];
                      } else if (data?.postDetails?.media && data.postDetails.media.length > 0) {
                        mediaObj = data.postDetails.media[0];
                      }
                      
                      if (!mediaObj) return null;
                      
                      const url = mediaObj.thumbnailUrl || mediaObj.fileUrl || "";
                      const typeStr = (mediaObj.mediaType || "").toUpperCase();
                      const isVideo = typeStr === "VIDEO" || !!url.toLowerCase().match(/\.(mp4|mov|wmv|avi|mkv|webm)$/);
                      
                      return {
                        url,
                        isVideo
                      };
                    };
                    const mediaInfo = getMediaInfo(item);

                    return (
                      <li key={item.id} style={{ padding: "2px 0px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gap: "2px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                            <span style={{ fontWeight: 500, fontSize: "14px" }}>
                              {i + 1}.
                            </span>
                            {mediaInfo && mediaInfo.isVideo ? (
                              <PlayCircleOutlineIcon sx={{ width: 24, height: 24, color: "#64748B" }} />
                            ) : mediaInfo && mediaInfo.url ? (
                              <img 
                                src={mediaInfo.url} 
                                alt="post media" 
                                style={{ width: 24, height: 24, borderRadius: "4px", objectFit: "cover" }} 
                              />
                            ) : null}
                            <span style={{ color: "#95919D", fontSize: "14px" }}>
                              {item?.content ? getDisplayContent(item.content) : "No content"}
                            </span>
                            <span style={{ fontWeight: 500, fontSize: "14px" }}>
                              {localTime}
                            </span>
                            <Chip
                              label={statusConfig.label}
                              size="small"
                              sx={{
                                backgroundColor: statusConfig.bg,
                                color: statusConfig.color,
                                fontSize: "11px",
                                fontWeight: 400,
                                borderRadius: "12px",
                                border: `1px solid ${statusConfig.border}`,
                                height: "22px",
                                ml: 1,
                              }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {item.isOrgPost ? (
                              <IconButton onClick={() => handleEditView(item)} title="View Details">
                                <VisibilityIcon sx={{ color: "#0047AB", width: "16px", height: "16px" }} />
                              </IconButton>
                            ) : item.isSuccess ? (
                              <>
                                <IconButton onClick={() => handleEditView(item)} title="View Details">
                                  <VisibilityIcon sx={{ color: "#0047AB", width: "16px", height: "16px" }} />
                                </IconButton>
                                <IconButton onClick={() => handleDiscard(item)} title="Delete">
                                  <DeleteOutlineIcon sx={{ color: "#DA4040", width: "14px", height: "14px" }} />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                <IconButton onClick={() => handleEditView(item)} title="Edit">
                                  <EditIcon sx={{ color: "#2D76DC", width: "14px", height: "14px" }} />
                                </IconButton>
                                <IconButton onClick={() => handleReschedule(item)} title="Reschedule">
                                  <ScheduleIcon sx={{ color: "#0047AB", width: "14px", height: "14px" }} />
                                </IconButton>
                                <IconButton onClick={() => handleDiscard(item)} title="Delete">
                                  <DeleteOutlineIcon sx={{ color: "#DA4040", width: "14px", height: "14px" }} />
                                </IconButton>
                              </>
                            )}
                          </div>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <li>No scheduled posts</li>
                )}
              </ul>
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={resetPasswordExpanded}
          onChange={(_, isExpanded) => setResetPasswordExpanded(isExpanded)}
          sx={accordionSx}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />
            }
            sx={accordionSummarySx}
          >
            <div className="reset-password">
              <div>
                <Typography variant="subtitle1" className="sub-title">
                  Reset Password
                </Typography>
                <Typography variant="body2" className="mini-title">
                  Secure your account by resetting your password.
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails sx={accordionDetailsSx}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              spacing={2}
            >
              <Typography sx={{ color: "#6B7280" }}>
                Update your password here without leaving the settings page.
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0047AB" }}
                onClick={() => setOpenResetPassword(true)}
              >
                Reset Password
              </Button>
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={accordionSx}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon sx={{ color: "#2D76DC", fontSize: "18px" }} />
            }
            sx={accordionSummarySx}
          >
            <div className="reset-password">
              <div>
                <Typography variant="subtitle1" className="sub-title">
                  Help & Onboarding Guide
                </Typography>
                <Typography variant="body2" className="mini-title">
                  Restart the step-by-step guided onboarding walkthrough.
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails sx={accordionDetailsSx}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              spacing={2}
            >
              <Typography sx={{ color: "#6B7280" }}>
                Need help navigating the system? Restart the tour to see key action spots.
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0047AB" }}
                onClick={() => onboarding.restartTour()}
              >
                Restart Guide Tour
              </Button>
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Dialog
        open={discard}
        onClose={() => setDiscard(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: { xs: "12px 14px", sm: "24px" },
            position: "relative",
          },
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={() => setDiscard(false)}
          sx={{ position: "absolute", top: { xs: 8, sm: 16 }, right: { xs: 8, sm: 16 } }}
        >
          <CloseIcon sx={{ color: "#000" }} />
        </IconButton>

        {/* Title */}
        <DialogTitle
          sx={{
            fontWeight: "500",
            color: "#3B3B3B",
            fontSize: { xs: "17px", sm: "22px" },
            p: 0,
            mb: { xs: 1, sm: 1.5 },
            pr: 4,
          }}
        >
          Delete schedule?
        </DialogTitle>

        {/* Subtitle */}
        <DialogContent sx={{ p: 0, mb: { xs: 1.5, sm: 3 } }}>
          <Typography
            sx={{
              color: "#95919D",
              fontSize: { xs: "14px", sm: "16px" },
              fontWeight: 400,
            }}
          >
            Deleting this schedule will stop the automatic sharing to your
            platforms
          </Typography>
        </DialogContent>

        {/* Buttons */}
        <DialogActions
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "flex-end",
            gap: { xs: 1, sm: 1.5 },
          }}
        >
          <Button
            onClick={handleCancel}
            disabled={deleteScheduleLoading}
            sx={{
              backgroundColor: "#F4F0FF",
              color: "#0047AB",
              borderRadius: "8px",
              textTransform: "none",
              border: "1px solid #F4F0FF",
              px: { xs: 2, sm: 4 },
              py: { xs: 0.6, sm: 1 },
              fontWeight: 500,
              fontSize: { xs: "13px", sm: "16px" },
              "&:hover": {
                backgroundColor: "#ece9fd",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={deleteScheduleLoading}
            sx={{
              backgroundColor: "#0047AB",
              color: "#fff",
              borderRadius: "8px",
              textTransform: "none",
              px: { xs: 2, sm: 4 },
              py: { xs: 0.6, sm: 1 },
              fontWeight: 500,
              fontSize: { xs: "13px", sm: "16px" },
              "&:hover": {
                backgroundColor: "#002f8c",
              },
            }}
          >
            {deleteScheduleLoading ? "Deleting..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <SchedulePostModal open={open} onClose={() => setOpen(false)} />

      <ResetPasswordModal
        open={openResetPassword}
        onClose={() => setOpenResetPassword(false)}
      />
      <Dialog 
        open={platformToggler} 
        onClose={() => setPlatformToggler(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: { xs: "12px 14px", sm: "20px" },
            position: "relative",
          },
        }}
      >
        <IconButton
          onClick={() => setPlatformToggler(false)}
          sx={{ position: "absolute", right: { xs: 8, sm: 16 }, top: { xs: 8, sm: 16 }, color: "#666" }}
        >
          <Close />
        </IconButton>

        <DialogTitle sx={{ p: 0, mb: { xs: 1, sm: 1.5 }, fontSize: { xs: "17px", sm: "20px" }, fontWeight: 600, pr: 4 }}>
          Platform Connections
        </DialogTitle>

        <DialogContent sx={{ p: 0, mb: { xs: 1.5, sm: 3 } }}>
          <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, color: "#3B3B3B" }}>
            {isDisconnect ? (
              <>
                Are you sure you want to <strong>disconnect</strong> this
                platform?
              </>
            ) : (
              <>
                Are you sure you want to <strong>connect</strong> this platform?
              </>
            )}
          </Typography>
          {platformActionError ? (
            <Typography sx={{ mt: 1.5 }} color="error">
              {platformActionError}
            </Typography>
          ) : null}
        </DialogContent>

        <DialogActions sx={{ p: 0, display: "flex", justifyContent: "flex-end", gap: { xs: 1, sm: 1.5 } }}>
          <Button
            onClick={() => setPlatformToggler(false)}
            disabled={isPlatformActionLoading}
            sx={{ textTransform: "none", borderRadius: "8px", px: { xs: 1.5, sm: 2.5 }, fontSize: { xs: "13px", sm: "14px" } }}
          >
            Cancel
          </Button>
          <Button
            onClick={enablePlatform}
            variant="contained"
            color={isDisconnect ? "error" : "primary"}
            disabled={isPlatformActionLoading}
            sx={{ textTransform: "none", borderRadius: "8px", px: { xs: 1.5, sm: 2.5 }, fontSize: { xs: "13px", sm: "14px" } }}
          >
            {isPlatformActionLoading
              ? "Please wait..."
              : isDisconnect
                ? "Disconnect"
                : "Connect"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog open={platformToggler} onClose={() => setPlatformToggler(false)}>
        <DialogTitle>
          Platform Connections
          <IconButton
            onClick={() => setPlatformToggler(false)}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          Are you sure you want to Connect this platform ?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPlatformToggler(false)}>Cancel</Button>
          <Button onClick={enablePlatform} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Edit/View Schedule Modal */}
      <EditScheduleModal
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setSelectedSchedulePost(null);
        }}
        scheduleData={selectedSchedulePost}
        onSave={handleEditSave}
        onDelete={selectedSchedulePost?.isOrgPost ? undefined : () => handleDiscard(selectedSchedulePost)}
        readOnly={selectedSchedulePost?.isOrgPost === true || selectedSchedulePost?.isSuccess === true || selectedSchedulePost?.isProcessed === true}
      />

      {/* Reschedule Modal */}
      <RescheduleModal
        open={rescheduleModalOpen}
        onClose={() => {
          setRescheduleModalOpen(false);
          setSelectedSchedulePost(null);
        }}
        scheduleData={selectedSchedulePost}
        onSave={handleRescheduleSave}
      />

      {/* Full Screen Calendar Modal */}
      <Dialog fullScreen open={calendarModalOpen} onClose={() => setCalendarModalOpen(false)}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Schedule Calendar
          <IconButton onClick={() => setCalendarModalOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <BigCalendar
            schedulePosts={displayedPosts}
            view={fullscreenView}
            onView={(view) => setFullscreenView(view)}
            onPostClick={(post) => {
              handleEditView(post);
              setSelectedPreviewPost(post);
            }}
            onViewMoreClick={(posts, dateStr, anchor) => {
              handleOpenViewMorePopup(posts, dateStr, anchor);
            }}
            onSelectEvent={(event, jsEvent) => {
              if (event.resource.isGrouped) {
                const anchor = jsEvent ? jsEvent.currentTarget || jsEvent.target : null;
                handleOpenViewMorePopup(event.resource.posts, event.resource.dateStr, anchor);
              } else {
                handleEditView(event.resource);
                setSelectedPreviewPost(event.resource);
              }
            }}
            containerSx={{
              height: 'calc(100vh - 100px)',
              background: "#fff",
              p: 2
            }}
          />
        </DialogContent>
      </Dialog>

      {/* View More Popover / Dialog */}
      {viewMoreAnchorEl ? (
        <Popover
          open={viewMoreOpen && Boolean(viewMoreAnchorEl)}
          anchorEl={viewMoreAnchorEl}
          onClose={() => {
            setViewMoreOpen(false);
            setViewMoreAnchorEl(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              borderRadius: "8px",
              padding: "8px 12px",
              width: "260px",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
              border: "1px solid #E2E8F0",
            }
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: "1px solid #E2E8F0" }}>
            <Typography sx={{ fontWeight: 600, fontSize: "12px", color: "#1E293B" }}>
              {viewMoreDate}
            </Typography>
            <IconButton onClick={() => { setViewMoreOpen(false); setViewMoreAnchorEl(null); }} size="small">
              <Close sx={{ fontSize: "12px" }} />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: "300px", overflowY: "auto", display: "flex", flexDirection: "column" }}>
            {viewMorePosts.map((item, i) => {
              const localTime = new Date(item.scheduledTimeUtc + (item.scheduledTimeUtc.endsWith('Z') ? '' : 'Z')).toLocaleTimeString(undefined, {
                hour: "2-digit",
                minute: "2-digit",
              });

              const getStatusConfig = () => {
                if (item.isProcessed !== true) {
                  return { bg: "#F4F4F4", color: "#757575", border: "#F4F4F4", label: "Not Processed" };
                }
                if (item.isSuccess === true) {
                  return { bg: "transparent", color: "#21AD0F", border: "transparent", label: <CheckIcon sx={{ fontSize: "16px" }} /> };
                }
                return { bg: "#FCEAE8", color: "#CC2D1A", border: "#F3A197", label: "Failed" };
              };

              const statusConfig = getStatusConfig();
              return (
                <Box
                  key={item.id}
                  onClick={() => {
                    handleEditView(item);
                    setSelectedPreviewPost(item);
                    setViewMoreOpen(false);
                    setViewMoreAnchorEl(null);
                  }}
                  sx={{
                    padding: "2px 0px",
                    borderBottom: i < viewMorePosts.length - 1 ? "1px solid #E2E8F0" : "none",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#F8FAFC",
                      "& span": { color: "#0284C7 !important" }
                    }
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap", gap: "4px", width: "100%", overflow: "hidden" }}>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", width: "100%", overflow: "hidden" }}>
                      <span style={{ fontWeight: 500, fontSize: "12px", flexShrink: 0 }}>{i + 1}.</span>{" "}
                      <span
                        style={{
                          color: "#95919D",
                          marginLeft: "4px",
                          fontSize: "12px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          flexShrink: 1,
                          minWidth: 0
                        }}
                        title={getDisplayContent(item?.content)}
                      >
                        {item?.content ? getDisplayContent(item.content) : "No content"}
                      </span>
                      {/* <span style={{ color: "#95919D", marginLeft: "4px", whiteSpace: "nowrap", flexShrink: 0 }}>
                        {" "}scheduled for
                      </span> */}
                      <span style={{ fontWeight: 500, fontSize: "12px", marginLeft: "4px", whiteSpace: "nowrap", flexShrink: 0 }}>{localTime}</span>
                      <Chip
                        label={statusConfig.label}
                        size="small"
                        sx={{
                          backgroundColor: statusConfig.bg,
                          color: statusConfig.color,
                          fontSize: "11px",
                          fontWeight: 400,
                          borderRadius: "12px",
                          border: `1px solid ${statusConfig.border}`,
                          height: "22px",
                          ml: 1,
                          flexShrink: 0,
                        }}
                      />
                    </div>
                  </div>
                </Box>
              );
            })}
          </Box>
        </Popover>
      ) : (
        <Dialog
          open={viewMoreOpen}
          onClose={() => setViewMoreOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
              padding: "8px"
            }
          }}
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: "1px solid #E2E8F0" }}>
            <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "#1E293B" }}>
              Scheduled Posts for {viewMoreDate}
            </Typography>
            <IconButton onClick={() => setViewMoreOpen(false)} size="small">
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ mt: 2, maxHeight: "400px", overflowY: "auto" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {viewMorePosts.map((item, i) => {
                const localTime = new Date(item.scheduledTimeUtc + (item.scheduledTimeUtc.endsWith('Z') ? '' : 'Z')).toLocaleTimeString(undefined, {
                  hour: "2-digit",
                  minute: "2-digit",
                });

                const getStatusConfig = () => {
                  if (item.isProcessed !== true) {
                    return { bg: "#F4F4F4", color: "#757575", border: "#F4F4F4", label: "Not Processed" };
                  }
                  if (item.isSuccess === true) {
                    return { bg: "transparent", color: "#21AD0F", border: "transparent", label: <CheckIcon sx={{ fontSize: "16px" }} /> };
                  }
                  return { bg: "#FCEAE8", color: "#CC2D1A", border: "#F3A197", label: "Failed" };
                };

                const statusConfig = getStatusConfig();
                return (
                  <Box
                    key={item.id}
                    onClick={() => {
                      handleEditView(item);
                      setSelectedPreviewPost(item);
                      setViewMoreOpen(false);
                      setViewMoreAnchorEl(null);
                    }}
                    sx={{
                      padding: "8px 0px",
                      borderBottom: i < viewMorePosts.length - 1 ? "1px solid #E2E8F0" : "none",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#F8FAFC",
                        "& span": { color: "#0284C7 !important" }
                      }
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap", gap: "4px", width: "100%", overflow: "hidden" }}>
                      <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", width: "100%", overflow: "hidden" }}>
                        <span style={{ fontWeight: 500, fontSize: "14px", flexShrink: 0 }}>{i + 1}.</span>{" "}
                        <span
                          style={{
                            color: "#95919D",
                            marginLeft: "4px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flexShrink: 1,
                            minWidth: 0
                          }}
                          title={getDisplayContent(item?.content)}
                        >
                          {item?.content ? getDisplayContent(item.content) : "No content"}
                        </span>
                        {/* <span style={{ color: "#95919D", marginLeft: "4px", whiteSpace: "nowrap", flexShrink: 0 }}>
                          {" "}
                        </span> */}
                        <span style={{ fontWeight: 500, fontSize: "15px", marginLeft: "4px", whiteSpace: "nowrap", flexShrink: 0 }}>{localTime}</span>
                        <Chip
                          label={statusConfig.label}
                          size="small"
                          sx={{
                            backgroundColor: statusConfig.bg,
                            color: statusConfig.color,
                            fontSize: "11px",
                            fontWeight: 400,
                            borderRadius: "12px",
                            border: `1px solid ${statusConfig.border}`,
                            height: "22px",
                            ml: 1,
                            flexShrink: 0,
                          }}
                        />
                      </div>
                    </div>
                  </Box>
                );
              })}
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Card>
  );
};

export default Settings;
